import { FC } from "react";
import { Lane, LaneLine } from "../models";
import { getConfiguredLaneName } from "../models/Shared.Lane.helpers";

interface LaneLabelProps {
    lanes: Lane | number | undefined;
    laneLines: LaneLine[] | undefined;
    emptyValue?: string;
}

// Displays configured lane names prominently with the raw "Lane N" label as secondary text.
// When no names are configured, only the raw label is shown.
export const LaneLabel: FC<LaneLabelProps> = ({ lanes, laneLines, emptyValue = "N/A" }) => {
    const decoded = getConfiguredLaneName(lanes, laneLines);
    if (!decoded) return <>{emptyValue}</>;
    return (
        <>
            {decoded.primary}
            {decoded.hasConfiguredName && <span className="ml-1 text-xs text-gray-400">({decoded.rawLabel})</span>}
        </>
    );
};
